var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "outfit-container" }, [
    _c(
      "div",
      { staticClass: "outfit-animation-container", class: _vm.animationClass },
      [
        _c("outfit-card", {
          attrs: { outfit: _vm.outfit, swapProductClk: function() {} }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "overlay",
            class: { "overlay--like": _vm.type === "like" }
          },
          [
            _c("img", {
              staticClass: "overlay-icon",
              attrs: { src: _vm.imageUrl(_vm.overlayIcon) }
            }),
            _vm._v(" "),
            _c("h3", { staticClass: "overlay-title" }, [
              _vm._v(_vm._s(_vm.title))
            ]),
            _vm._v(" "),
            _c("h5", { staticClass: "overlay-subtext" }, [
              _vm._v(_vm._s(_vm.subtext))
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "outfit-card-placeholder" })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5797c0e6", { render: render, staticRenderFns: staticRenderFns })
  }
}